var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "follows" }, [_vm._v("FOLLOW US")]),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "iconBox" },
        _vm._l(_vm.iconList, function(item) {
          return _c(
            "span",
            {
              key: item.id,
              class: item.id == 4 && !_vm.isMobile ? "hidden_weixin" : ""
            },
            [
              item.id == 4
                ? _c("span", { on: { click: _vm.nativeShareCall } }, [
                    _c("img", { attrs: { src: item.imgUrl, alt: "" } })
                  ])
                : _c("a", { attrs: { href: item.href } }, [
                    _c("img", { attrs: { src: item.imgUrl, alt: "" } })
                  ])
            ]
          )
        }),
        0
      )
    ]),
    !_vm.isMobile
      ? _c("div", { staticClass: "pageTop", on: { click: _vm.pageTop } }, [
          _c("div", { staticClass: "imgBox" }, [
            _c("img", {
              attrs: { src: require("@/assets/img/website/top.png"), alt: "" }
            })
          ]),
          _c("div", { staticClass: "text" }, [_vm._v("PAGE TOP")])
        ])
      : _c("div", { staticClass: "mbTop", on: { click: _vm.pageTop } }, [
          _c("img", {
            attrs: { src: require("@/assets/img/website/mb-top.png"), alt: "" }
          })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./node_modules/vue-loader/lib?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./src/views/components/footer.vue?vue&type=template&id=3c270e0a&scoped=true&
// module id = 295
// module chunks = 0 1 2